var PROPER_FUNCTION_NAME = require('../internals/function-name').PROPER;

var fails = require('../internals/fails');

var whitespaces = require('../internals/whitespaces');

var non = "\u200B\x85\u180E"; // check that a method works with the correct list
// of whitespaces and has a correct name

module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};